<app-toolbar></app-toolbar>

<div class="mat-small warn-color software-version">
  V. {{ softwareVersion }}
</div>

<div id="spinner-container" *ngIf="processStatus.status == ProcessStatusEnum.pending">
  <mat-spinner></mat-spinner>
</div>

<router-outlet></router-outlet>
